import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import {
    formataEstudoHipotesesRetorno,
} from '../../../business-components/Formata/Formata'

import {
    GridContainer,
    GridItem11,
    GridItem12,
 } from '../../../business-components/Grid/Grid'

 import {
    CardGridEstudo,
    CardGridDivHeaderDestaque1,
    CardGridDivH4Destaque,
    CardGridDivBody,
} from '../../../business-components/Card/Card'

import {
    ChartPadrao
} from '../../../business-components/Chart/Chart'

import {
    GridContainerEstudoPadraoMd,
} from '../estudo-form/EstudoComp'

import {
    calcValorPresenteDeficitSimulacaoMensalValorAporteMensalPreservarReservaAposentadoria,
    processaValoresDefaultIniciaisHipotesesRetornoRealProjetoVidaSonhoTracarMetaChart
} from './HipotesesRetornoRealProjetoVidaSonhoTracarMetaChartService'



const ProjetoVidaSonhoTracarMetaChart = ( { values, handleSubmitAutomatico, estudo, report, jsonConfiguracao,
    indInicial, indFinal } ) => {

    if (
            values.naoExibirHipotesesRetornoRealAposentadoria ||
            calcValorPresenteDeficitSimulacaoMensalValorAporteMensalPreservarReservaAposentadoria(values) === 0
    ) {

        processaValoresDefaultIniciaisHipotesesRetornoRealProjetoVidaSonhoTracarMetaChart(values,
            handleSubmitAutomatico, estudo, report, jsonConfiguracao, LABEL.aposentadoria)
    }

    const ProjetoVidaSonhoTracarMeta = ( props ) => {

        const { item, ind, ...rest } = props

        const calculaSeries = ( item, ind ) => {

            const series = []
    
            const data = []
    
            estudo.current.graficoProjetoVidaSonhoTracarMeta?.forEach(
                (linhaGraficoProjetoVidaSonhoTracarMeta, indLinhaGraficoProjetoVidaSonhoTracarMeta) => {
    
                data.push(
                    linhaGraficoProjetoVidaSonhoTracarMeta[ind].valorAporteProjetoVidaSonho
                )
            })

            data?.forEach( (linha, ind) => {

                const data2 = []
    
                data?.forEach( (linha2, ind2) => {
    
                    data2.push(
                        ind === ind2
                            ?
                                linha
                            :
                                null
                    )
                })
    
                series.push(
                    {
                        name: LABEL.aporteMensal,
                        type: 'bar',
                        data: data2,
                    },
                )
    
            })
    
            return series
        }
    
        const categories = estudo.current.percHipotesesRetornoRealProjetoVidaSonhoTracarMetaList
    
        const GridGrafico = report ? GridItem11 : GridItem11

        return (

            <div
                {...rest}
            >
                 <GridContainer>
                    <GridGrafico>
                        <ChartPadrao
                            titleText={
                                LABEL.hipotesesRetornoReal + ': ' +
                                    item.nomeCurtoFamiliar + ' - ' + item.descricao
                            }
                            type="area"
                            distributed={true}
                            series={calculaSeries(item, ind)}
                            stacked={true}
                            categories={categories}
                            paletaCores={estudo.current.coresHipotesesRetornoRealProjetoVidaSonhoTracarMetaList}
                            columnWidth='70%'
                            report={report}
                            formatoReport={values.formatoReport}
                            fillOpacity={0.8}
                            dataLabelsEnabled={true}
                            dataLabelsEnabledReport={true}
                            dataLabelsType="Large"
                            xaxisType="Large"
                            notLegendShow={true}
                        />
                    </GridGrafico>
                </GridContainer>
            </div>
        )
    }

    return (
        estudo.current.graficoProjetoVidaSonhoTracarMeta && 
        estudo.current.graficoProjetoVidaSonhoTracarMeta[0].length > 0
            ?
                estudo.current.projetoVidaSonhoTracarMeta?.map((item, ind) => {
                    return (!indFinal || (ind >= indInicial && ind <= indFinal)) && (
                        <GridItem12
                            key={ind}
                        >
                            {report
                                ?
                                    <ProjetoVidaSonhoTracarMeta
                                        className="mt-10 ml-5"
                                        item={item}
                                        ind={ind}
                                    />
                                :
                                    <GridContainerEstudoPadraoMd
                                        component={
                                            <CardGridEstudo>
                                                <CardGridDivHeaderDestaque1>
                                                    <GridContainer>
                                                        <GridItem12>
                                                            <CardGridDivH4Destaque>
                                                                {formataEstudoHipotesesRetorno(LABEL.hipotesesRetornoReal,
                                                                    item.nomeCurtoFamiliar + ' - ' + item.descricao)}
                                                            </CardGridDivH4Destaque>
                                                        </GridItem12>
                                                    </GridContainer>
                                                </CardGridDivHeaderDestaque1>

                                                <CardGridDivBody>
                                                    <ProjetoVidaSonhoTracarMeta
                                                        item={item}
                                                        ind={ind}
                                                    />
                                                </CardGridDivBody>
                                            </CardGridEstudo>
                                        }
                                    />
                            }
                        </GridItem12>
                    )
                })
            :
                ''
    )
}

export default ProjetoVidaSonhoTracarMetaChart